<template>
<div class="OrderCodes">
    <v-card>
        <v-card-title>Просмотр кодов заявки №{{order_id}}</v-card-title>
        <v-card-text>
            <v-select :items="variant_list"
                label="вариант для печати"
                item-value="v"
                item-text="d"
                v-model="variant"
                @change="draw"
            />
            <template v-if="result_codes.length">
                <v-btn color="primary" @click="printBarcodes()">Напечатать</v-btn>
                <div v-for="(c,idx) in result_codes">
                    <canvas :ref="'barcode-' + idx" class="barcode-canvas" />
                </div>
            </template>
        </v-card-text>
    </v-card>
</div>
</template>
<script>
import JsBarcode from 'jsbarcode';
export default {
    created(){
        let t=this
        t.order_id=location.pathname.replace(/[^\d+]/g,'')
        t.$http.get(`${BackendBase}/delivery/codes-for-order/${t.order_id}`).then(
            r=>{
                let d=r.data

                if(d.success){
                    t.codes=d.codes
                    t.draw()
                }
            }

        )


    },
    methods:{
        draw(){
            let t=this
            // подготавливаем список
            t.result_codes=[]
            for(let c of t.codes){
                if(
                    (t.variant=='all') ||
                    (t.variant=='receipt_code' && c.type=='receipt_code') || // Код партнёра
                    (t.variant=='plomb_code' && c.type=='plomb_code') || // Код пломбы
                    (t.variant=='num_place' && c.type=='num_place') || // код места
                    (t.variant=='receipt_and_plomb' && (c.type=='receipt_code' || c.type=='plomb_code') ) || // Код партнёра + Код пломбы
                    (t.variant=='order_id' && (c.type=='order_id') )

                ){
                    t.result_codes.push(c.value)
                }
            }
            console.log('result_codes: ',t.result_codes)
            t.$nextTick(()=>{
                        t.result_codes.forEach((code, index) => {
                          const canvas = t.$refs[`barcode-${index}`];
                          if (canvas) {
                            JsBarcode(canvas, code, {
                              format: 'CODE128',
                              //displayValue: true,
                              fontSize: 15,
                              margin: 10
                            });
                          }
                        })
            });
        },
        printBarcodes() {
            // Создаем новое окно для печати
            const printWindow = window.open('', '_blank');

            // Создаем HTML для печати
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Печать штрих-кодов</title>
                    <style>
                        body {
                            margin: 0;
                            padding: 20px;
                            font-family: Arial, sans-serif;
                        }
                        .barcode-container {
                            page-break-inside: avoid;
                            margin-bottom: 20px;
                            text-align: center;
                        }
                        .barcode-canvas {
                            width: 100% !important;
                            max-width: 300px;
                            height: auto;
                        }
                        @media print {
                            body {
                                padding: 0;
                            }
                            .barcode-container {
                                margin-bottom: 0;
                            }
                        }
                    </style>
                </head>
                <body>
                    <div id="barcodes"></div>
                </body>
                </html>
            `);

            // Копируем canvas элементы в новое окно
            const barcodesContainer = printWindow.document.getElementById('barcodes');

            this.result_codes.forEach((code, index) => {
                const canvas = this.$refs[`barcode-${index}`][0];
                if (canvas) {
                    const container = printWindow.document.createElement('div');
                    container.className = 'barcode-container';

                    const newCanvas = printWindow.document.createElement('canvas');
                    newCanvas.width = canvas.width;
                    newCanvas.height = canvas.height;

                    const ctx = newCanvas.getContext('2d');
                    ctx.drawImage(canvas, 0, 0);

                    container.appendChild(newCanvas);
                    barcodesContainer.appendChild(container);
                }
            });

            // Даем время на рендеринг и запускаем печать
            printWindow.document.close();
            setTimeout(() => {
                printWindow.print();
                printWindow.close();
            }, 250);
        },
    },

    data(){
        return {
            codes:[],
            result_codes:[],
            variant:'all',
            variant_list:[
                {v:'all',d:'печатаем всё'},
                {v:'receipt_code',d:'Код партнёра'},
                {v:'plomb_code',d:'Код пломбы'},
                {v:'num_place',d:'Код места'},
                {v:'receipt_and_plomb',d:'Код партнёра + код пломбы'},
                {v:'order_id',d:'Номер заявки'},

            ],
            order_id:null
        }
    }
}
</script>
<style scoped>
    .OrderCodes {margin: 20px; width: 100%; max-width: 1280px;}
    .barcode-canvas {width: 50% !important;}
</style>